import { Reveal } from '@/components/ui/Reveal'
import { galleryImages } from '@/data/courses'
import courseOne from '@/assets/optimized/Website photos/Course 1.jpg'
import courseTwo from '@/assets/optimized/Website photos/Edited Coure Photo 2.jpg'
import herbalWalk from '@/assets/optimized/Website photos/Herbal Walk 1.jpg'

const images = [courseOne, courseTwo, herbalWalk]

export const CoursesGallery = () => (
  <section className="bg-base-50 pt-12 sm:pt-16">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid gap-4 sm:grid-cols-3">
        {galleryImages.map((img, index) => (
          <Reveal key={img.label} delay={index * 80}>
            <figure>
              <img
                src={images[index]}
                alt={img.caption}
                className="aspect-[4/3] w-full rounded-3xl border border-base-200 object-cover"
                loading="lazy"
              />
              <figcaption className="mt-3 text-sm text-base-500">{img.caption}</figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
)
